module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module container_lg module-five"
  }, [_c('div', {
    staticClass: "scene"
  }, [_c('lab_background', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.labBackgroundActive),
      expression: "labBackgroundActive"
    }]
  }), _vm._v(" "), _c('div', {
    staticClass: "layer"
  }, [_c('library_background', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.libraryBackgroundActive),
      expression: "libraryBackgroundActive"
    }]
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "layer"
  }, [_c('devyn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.devyn_present),
      expression: "devyn_present"
    }],
    attrs: {
      "data": _vm.devynData
    }
  }), _vm._v(" "), _c('svg', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ria_present),
      expression: "ria_present"
    }],
    attrs: {
      "id": "ria",
      "data": _vm.riaData,
      "width": "160",
      "height": "500",
      "viewBox": "0 0 160 500"
    }
  }, [_c('path', {
    attrs: {
      "id": "ria_left_foot_2",
      "fill": "#CC9D69",
      "fill-rule": "nonzero",
      "d": "M103.82 449c.1 19.56 16.03 28.26 21.9 31.88-7.24 1.47-38.12-1.46-39.98-3.62.3-6.16 3.9-18.08 3.42-28.25-.2-6.05 14.66-2.14 14.66 0z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_left_foot_1",
      "fill": "#BC2F2F",
      "fill-rule": "nonzero",
      "d": "M121.9 477.75c.4.6-4.2-4.9-5.67-6.35-2.15 0-10.16 1.46-13.78 2.93 3.62 4.4 5.38 5.97 1.47 5.1-11.24-2.17-15.64-2.65-18.08-3.63-2.74 3.22-3.7 13.1-2.25 15.93 3.6 2.16 10.35 1.76 12.1 1.57.6-.7.5-1.86 2.26-1.37 1.17.3 1.27 1.08 1.95 1.66 3.04.97 38.22-.4 41.16-1.08 4.98-1.18 3.9-6.65 0-8.02-7.63-2.74-17.2-5.87-19.16-6.75z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_left_leg_bottom",
      "fill": "#2B5189",
      "fill-rule": "nonzero",
      "d": "M77.53 465.04h43.4V366.3c0-11.74-9.5-21.22-21.2-21.22h-.7c-11.82 0-21.5 9.58-21.5 21.5v98.46z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_left_leg_top",
      "fill": "#2B5189",
      "fill-rule": "nonzero",
      "d": "M99.23 388.5c12.02 0 21.7-9.7 21.7-21.72v-76.55c0-12.03-9.68-21.7-21.7-21.7s-21.7 9.67-21.7 21.7v76.55c0 11.93 9.68 21.7 21.7 21.7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_right_foot_2",
      "fill": "#D8A96F",
      "fill-rule": "nonzero",
      "d": "M52.02 449c.1 19.56 16.03 28.26 21.9 31.88-7.24 1.47-38.12-1.46-39.98-3.62.3-6.16 3.9-18.08 3.43-28.25-.2-6.05 14.65-2.14 14.65 0z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_right_foot_1",
      "fill": "#C92F2F",
      "fill-rule": "nonzero",
      "d": "M70.1 477.75c.4.6-4.2-4.9-5.66-6.35-2.15 0-10.17 1.46-13.78 2.93 3.6 4.4 5.37 5.97 1.46 5.1-11.24-2.17-15.63-2.65-18.08-3.63-2.73 3.22-3.7 13.1-2.25 15.93 3.6 2.16 10.35 1.76 12.1 1.57.6-.7.5-1.86 2.26-1.37 1.17.3 1.27 1.08 1.96 1.66 3.03.97 38.2-.4 41.14-1.08 4.98-1.18 3.9-6.65 0-8.02-7.62-2.74-17.2-5.87-19.16-6.75z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_right_leg_bottom",
      "fill": "#2F539B",
      "fill-rule": "nonzero",
      "d": "M25.74 465.04h43.4V366.3c0-11.74-9.5-21.22-21.22-21.22h-.68c-11.83 0-21.5 9.58-21.5 21.5v98.46z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_right_leg_top",
      "fill": "#2F539B",
      "fill-rule": "nonzero",
      "d": "M47.43 388.5c12.02 0 21.7-9.7 21.7-21.72v-76.55c0-12.03-9.68-21.7-21.7-21.7s-21.7 9.67-21.7 21.7v76.55c0 11.93 9.68 21.7 21.7 21.7z"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "ria_left_arm"
    }
  }, [_c('path', {
    attrs: {
      "id": "ria_left_arm_top",
      "fill": "#DDD",
      "fill-rule": "nonzero",
      "d": "M121.05 223.3l1.16-.18c9.1-1.27 15.43-9.67 14.15-18.77l-8.62-61.38c-1.28-9.1-9.67-15.43-18.77-14.15l-1.16.16c-9.1 1.28-15.42 9.68-14.14 18.78l8.63 61.38c1.27 9.1 9.65 15.43 18.75 14.15z"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "ria_original_left_arm"
  }, [_c('g', {
    attrs: {
      "id": "ria_default_left_arm"
    }
  }, [_c('g', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ria_original_left_arm_state),
      expression: "ria_original_left_arm_state"
    }],
    staticClass: "ria_original_left_arm"
  }, [_c('g', {
    attrs: {
      "id": "ria_default_left_arm"
    }
  }, [_c('g', {
    attrs: {
      "id": "ria_left_arm_hand"
    }
  }, [_c('path', {
    attrs: {
      "id": "ria_left_hand",
      "fill": "#D8A96F",
      "d": "M136.56 267.3c.53 3 1.5 9.66 8.57 17.88 3.36 3.9 4.44 11.8 8.48 17.9-.55 1.68-6.02-.3-7.5-2.8-1.47-2.48-2.62-4.5-3.1-5.12-.45-.6-1.32-.4-1.47.27-.16.68 3.23 23.92 2.9 25.15-.36 1.23-3.4 1.8-4.12.72-.72-1.08-3.87-19.38-4.2-19.83-.35-.44-.98-.1-1.2.22-.25.3 3.68 19.74 3.35 20.55-.32.8-3.47 1.23-3.92.7-.44-.55-4-20-4.4-20.4-.43-.37-1.1-.2-1.32.24-.2.44 3.87 19.05 3.53 19.94-.35.9-3.38 1.44-3.8.67-.43-.75-4.38-19.5-4.72-19.73-.33-.22-.72-.12-.96.18-.23.3 1.95 14.43 1.6 15.28-.35.85-2.6 1.44-3.12.55-.5-.88-4.37-24.82-4.24-30.4.13-5.6.4-15.87-.08-18.58 1.1-.2 17.55-3.02 19.76-3.4z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_left_arm_bottom",
      "fill": "#DDD",
      "fill-rule": "nonzero",
      "d": "M114.33 285.74l31.45-4.42c.78-.1 1.28-.77 1.17-1.55L136.2 203.2c-1.3-9.1-9.68-15.44-18.78-14.16l-1.16.17c-9.1 1.3-15.42 9.68-14.14 18.78l10.76 76.58c.1.68.77 1.28 1.45 1.18z"
    }
  })])])])])])]), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_coat_right",
      "fill": "#F4F4F4",
      "fill-rule": "nonzero",
      "d": "M5.2 383.5s-.96 8.8 67.45 8.8c5.57 0 10.55-.1 15.24-.2.38-10.55.38-267.7.1-280.2-4.7-1.38-9.7-2.16-14.87-2.16-27.16 0-49.74 21.12-51.5 48.3L5.2 383.5z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_coat_left",
      "fill": "#EAEAEA",
      "fill-rule": "nonzero",
      "d": "M87.22 392.1c52.86-1.17 52.86-8.6 52.86-8.6l-16.33-225.46c-1.45-22-16.42-40.1-36.43-46.15.3 9.57.3 273.56-.1 280.2z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_shirt",
      "fill": "#2F539B",
      "fill-rule": "nonzero",
      "d": "M88.28 148.85l6.84-33.24H70.7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_neck",
      "fill": "#CC9D69",
      "fill-rule": "nonzero",
      "d": "M94.15 95.07c-2.94 9.78-2.15 16.82 2.93 21.5-6.06 6.08-24.43 5.88-33.23 1 2.93-4.9 6.84-10.76 1.95-22.5.98-14.66 30.3-12.7 28.35 0z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_collar_2",
      "fill": "#FFF",
      "fill-rule": "nonzero",
      "d": "M67.76 107.8l20.52 41.05-28.34-10.76L58 110.7c2.92-.98 6.83-1.96 9.76-2.93z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_collar_1",
      "fill": "#F4F4F4",
      "fill-rule": "nonzero",
      "d": "M94.15 112.67L88 148.85l16.9-8.8-2.94-22.5c-2.54-1.55-6.06-3.6-7.8-4.88z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_coat_pocket",
      "fill": "#F4F4F4",
      "fill-rule": "nonzero",
      "d": "M118.58 171.34l-22.48 4.9v6.83l22.48-4.9z"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "ria_right_arm"
    }
  }, [_c('g', {
    attrs: {
      "id": "ria_right_arm_hand"
    }
  }, [_c('path', {
    attrs: {
      "id": "ria_right_hand",
      "fill": "#D8A96F",
      "d": "M42.43 268.07c0 3.05-.2 9.8 5.33 19.1 2.63 4.45 2.32 12.4 5.24 19.13-.84 1.54-5.88-1.37-6.9-4.08-1.02-2.7-1.8-4.9-2.16-5.58-.35-.68-1.24-.63-1.5 0-.28.66-.97 24.13-1.53 25.28-.55 1.15-3.62 1.2-4.15 0-.54-1.2-.46-19.76-.72-20.26-.26-.5-.94-.26-1.23 0-.28.26.2 20.1-.25 20.83-.46.73-3.64.6-3.98 0-.34-.62-.46-20.4-.8-20.84-.35-.45-1.05-.4-1.34 0-.3.4.5 19.44 0 20.26-.5.82-3.58.83-3.86 0-.28-.83-.9-19.98-1.2-20.26-.3-.28-.7-.25-1 0-.28.25-.58 14.55-1.07 15.33-.5.77-2.83.95-3.17 0-.35-.97 0-25.22 1.1-30.7 1.1-5.47 3.14-15.55 3.14-18.3l20.06.07z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_right_arm_bottom",
      "fill": "#FFF",
      "fill-rule": "nonzero",
      "d": "M18.6 284.46h31.76c.8 0 1.37-.6 1.37-1.37v-77.35c0-9.2-7.43-16.62-16.6-16.62h-1.2c-9.17 0-16.6 7.43-16.6 16.62v77.34c0 .67.6 1.36 1.27 1.36z"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_right_arm_top",
      "fill": "#FFF",
      "fill-rule": "nonzero",
      "d": "M33.94 223.55h1.18c9.18 0 16.6-7.43 16.6-16.62v-62c0-9.18-7.42-16.6-16.6-16.6h-1.18c-9.18 0-16.6 7.42-16.6 16.6v62c0 9.2 7.42 16.62 16.6 16.62z"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "ria_head"
    }
  }, [_c('path', {
    attrs: {
      "id": "ria_face",
      "fill": "#D8A96F",
      "fill-rule": "nonzero",
      "d": "M49.3 64.57c0 22.4 16.2 41.75 34.1 41.75 22.57 0 30.88-22.78 30.88-41.75 0-29.92-12.4-40.38-32.45-40.38-17.98-.1-32.54 17.88-32.54 40.37z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_hair",
      "fill": "#CCC",
      "fill-rule": "nonzero",
      "d": "M107.73 21.94c-6.06-5.86-19.15-19.46-45.05-13.3C40.48 13.92 42.54 32 37.76 37.1c-7.82 8.2-13.4 4.98-17.7 14.47-3.32 7.33 2.26 13 .2 20.53C18.9 77.08 6 95.86 32.2 99.38c27.55 3.7 19.73-20.34 20.12-28.26.3-6.35 9.48-2.54 17.6-12.7C77.13 49.3 72.83 32 75.66 28c4-5.57 18.96-3.13 25.5 1.27 13.1 8.6 18.58 40.87 5.88 63.85 9.18 13.2 40.85 4.7 23.74-20.63-5.28-7.83 5.37-12.04-1.28-24.84-5.76-11.15-21.8-25.72-21.8-25.72z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_mouth_open_bottom",
      "fill": "#9E6954",
      "fill-rule": "nonzero",
      "d": "M95.03 92.16c.97.98-.1 6.07-4.1 6.07-4.02 0-8.4-5-8.12-5.48.3-.5 4.4 2.44 8.12 2.44 4-.1 4.1-3.04 4.1-3.04z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_mouth_bottom",
      "fill": "#9E6954",
      "fill-rule": "nonzero",
      "d": "M96 92.92c-1.56.4-10.36.5-13.3-.1-1.55-.3 1.97 2.65 7.83 2.65S96 92.92 96 92.92z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_mouth_top",
      "fill": "#634235",
      "fill-rule": "nonzero",
      "d": "M96.98 92.83c0-1.28-.98-2.35-6.06-2.35-3.52 0-9.2 1.76-12.02.98-.6-.2-.6.3.2.58 3.6 1.27 7.13 1.27 12.5 1.27 3.52-.08 5.38-.47 5.38-.47z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_nose",
      "fill": "#C99B69",
      "fill-rule": "nonzero",
      "d": "M88.67 82.36h3.03c1.27 0 2.25-.97 2.25-2.24L92.78 63.3c0-1.27-.98-2.25-2.25-2.25h-.78c-1.27 0-2.25.98-2.25 2.25l-1.17 16.82c.1 1.17 1.17 2.24 2.34 2.24z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_glasses_4",
      "fill": "#C92F2F",
      "fill-rule": "nonzero",
      "d": "M92 64.67c0-8.6 7.03-15.55 15.53-15.55 8.6 0 15.64 6.94 15.64 15.65 0 8.7-6.94 15.64-15.64 15.64-8.6 0-15.53-6.93-15.53-15.54v1.08h-3.62v-1.86H92v.6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_glasses_3",
      "fill": "#C92F2F",
      "fill-rule": "nonzero",
      "d": "M72.74 80.4c-8.63 0-15.63-7-15.63-15.63 0-8.64 7-15.65 15.64-15.65s15.64 7 15.64 15.65c0 8.64-7 15.64-15.64 15.64z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_glasses_2",
      "fill": "#FFF",
      "fill-rule": "nonzero",
      "d": "M107.53 78.65c-7.66 0-13.87-6.22-13.87-13.88 0-7.67 6.2-13.9 13.87-13.9 7.67 0 13.88 6.23 13.88 13.9 0 7.66-6.2 13.88-13.87 13.88z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_glasses_1",
      "fill": "#FFF",
      "fill-rule": "nonzero",
      "d": "M72.74 78.65c-7.66 0-13.87-6.22-13.87-13.88 0-7.67 6.2-13.9 13.87-13.9 7.67 0 13.88 6.23 13.88 13.9 0 7.66-6.2 13.88-13.88 13.88z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_right_brow",
      "fill": "#9E6954",
      "fill-rule": "nonzero",
      "d": "M99.72 47.17c1.95-.1 12.02-.4 15.93.1 1.85.2-2.35-2.94-9.4-2.94-7.02 0-6.53 2.84-6.53 2.84z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_left_brow",
      "fill": "#9E6954",
      "fill-rule": "nonzero",
      "d": "M80.85 47.26c-1.95-.1-12.3-.48-16.32.1-1.85.3 2.45-3.03 9.58-3.03 7.24 0 6.75 2.93 6.75 2.93z"
    }
  })]), _vm._v(" "), _c('g', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ria_duplicate_left_arm_state),
      expression: "ria_duplicate_left_arm_state"
    }],
    attrs: {
      "id": "ria_left_arm_outer"
    }
  }, [_c('path', {
    attrs: {
      "id": "left_hand",
      "fill": "#D8A96F",
      "d": "M136.56 267.3c.53 3 1.5 9.66 8.57 17.88 3.36 3.9 4.44 11.8 8.48 17.9-.55 1.68-6.02-.3-7.5-2.8-1.47-2.48-2.62-4.5-3.1-5.12-.45-.6-1.32-.4-1.47.27-.16.68 3.23 23.92 2.9 25.15-.36 1.23-3.4 1.8-4.12.72-.72-1.08-3.87-19.38-4.2-19.83-.35-.44-.98-.1-1.2.22-.25.3 3.68 19.74 3.35 20.55-.32.8-3.47 1.23-3.92.7-.44-.55-4-20-4.4-20.4-.43-.37-1.1-.2-1.32.24-.2.44 3.87 19.05 3.53 19.94-.35.9-3.38 1.44-3.8.67-.43-.75-4.38-19.5-4.72-19.73-.33-.22-.72-.12-.96.18-.23.3 1.95 14.43 1.6 15.28-.35.85-2.6 1.44-3.12.55-.5-.88-4.37-24.82-4.24-30.4.13-5.6.4-15.87-.08-18.58 1.1-.2 17.55-3.02 19.76-3.4z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_left_arm_bottom",
      "fill": "#DDD",
      "fill-rule": "nonzero",
      "d": "M114.33 285.74l31.45-4.42c.78-.1 1.28-.77 1.17-1.55L136.2 203.2c-1.3-9.1-9.68-15.44-18.78-14.16l-1.16.17c-9.1 1.3-15.42 9.68-14.14 18.78l10.76 76.58c.1.68.77 1.28 1.45 1.18z"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "ria_right_arm_outer"
    }
  }, [_c('g', {
    attrs: {
      "id": "ria_right_arm"
    }
  }, [_c('g', {
    attrs: {
      "id": "ria_right_arm_hand"
    }
  }, [_c('path', {
    attrs: {
      "id": "ria_right_hand",
      "fill": "#D8A96F",
      "d": "M42.43 268.07c0 3.05-.2 9.8 5.33 19.1 2.63 4.45 2.32 12.4 5.24 19.13-.84 1.54-5.88-1.37-6.9-4.08-1.02-2.7-1.8-4.9-2.16-5.58-.35-.68-1.24-.63-1.5 0-.28.66-.97 24.13-1.53 25.28-.55 1.15-3.62 1.2-4.15 0-.54-1.2-.46-19.76-.72-20.26-.26-.5-.94-.26-1.23 0-.28.26.2 20.1-.25 20.83-.46.73-3.64.6-3.98 0-.34-.62-.46-20.4-.8-20.84-.35-.45-1.05-.4-1.34 0-.3.4.5 19.44 0 20.26-.5.82-3.58.83-3.86 0-.28-.83-.9-19.98-1.2-20.26-.3-.28-.7-.25-1 0-.28.25-.58 14.55-1.07 15.33-.5.77-2.83.95-3.17 0-.35-.97 0-25.22 1.1-30.7 1.1-5.47 3.14-15.55 3.14-18.3l20.06.07z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_right_arm_bottom",
      "fill": "#FFF",
      "fill-rule": "nonzero",
      "d": "M18.6 284.46h31.76c.8 0 1.37-.6 1.37-1.37v-77.35c0-9.2-7.43-16.62-16.6-16.62h-1.2c-9.17 0-16.6 7.43-16.6 16.62v77.34c0 .67.6 1.36 1.27 1.36z"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_right_arm_top",
      "fill": "#FFF",
      "fill-rule": "nonzero",
      "d": "M33.94 223.55h1.18c9.18 0 16.6-7.43 16.6-16.62v-62c0-9.18-7.42-16.6-16.6-16.6h-1.18c-9.18 0-16.6 7.42-16.6 16.6v62c0 9.2 7.42 16.62 16.6 16.62z"
    }
  })])])]), _vm._v(" "), _c('aye', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.aye_present),
      expression: "aye_present"
    }],
    attrs: {
      "data": _vm.ayeData
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "layer"
  }, [_c('transition', {
    attrs: {
      "name": "modal-fade"
    }
  }, [(_vm.showBlackOverlay) ? _c('div', {
    staticClass: "layer"
  }, [_c('div', {
    staticClass: "layer"
  }, [_c('div', {
    staticClass: "black-overlay"
  })]), _vm._v(" "), _c('div', {
    staticClass: "layer"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('h1', {
    staticClass: "modal_text h1-large"
  }, [_vm._v("A Few Minutes Later")]), _vm._v(" "), _c('p', {
    staticClass: "modal_text"
  }, [_vm._v("Location: Library")])])])]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lib_door_present),
      expression: "lib_door_present"
    }],
    staticClass: "layer"
  }, [_c('library_doors', {
    attrs: {
      "data": _vm.libDoorsData,
      "showOnEdge": _vm.showDoorsOnEdge
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "layer",
    style: (_vm.labDoorsStyle)
  }, [_c('lab_doors', {
    attrs: {
      "data": _vm.labDoorsData,
      "showOnEdge": _vm.showDoorsOnEdge
    }
  })], 1)], 1), _vm._v(" "), _c('modal', {
    staticClass: "layer layer-full index-2",
    attrs: {
      "active": _vm.modalActive,
      "text": _vm.modalText,
      "ind": _vm.modalInd,
      "modalStyle": _vm.modalStyle
    },
    on: {
      "close": _vm.closeModalLayer
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "layer layer-full index-2",
    class: _vm.modalLayerClass
  }, [_c('storyModal', {
    attrs: {
      "storyModalActive": _vm.storyModalActive,
      "text": _vm.storyText[0],
      "ind": _vm.storyModalInd
    },
    on: {
      "close": _vm.closeStoryModalLayer
    }
  })], 1), _vm._v(" "), _c('control-panel', {
    attrs: {
      "text": _vm.activeText,
      "control_panel_active": _vm.controlPanelActive
    },
    on: {
      "textProgress": _vm.updateScene
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-156cfc20","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/module_5/module_5.vue
// module id = 943
// module chunks = 1